import isNil from 'lodash/isNil'
import React from 'react'

import { DashboardPermissionGuard } from '@components/utils/DashboardPermissions'
import { Icon, PriceString, ProfitString } from '@fourthwall/components'
import { ArrowShortRightIcon } from '@fourthwall/icons'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import { formatCurrency } from '@fourthwall/utils/dist/currency'

import * as S from './styled'

type ExplicitSellingPriceListItem = {
  offerVariant: Offer.Variant
}

export const ExplicitSellingPriceListItem = ({ offerVariant }: ExplicitSellingPriceListItem) => {
  const cost = offerVariant.cost?.value
  const profit = !isNil(cost) ? formatCurrency(offerVariant.price.value - cost) : 0

  return (
    <S.Container>
      <S.Content>
        <div>{offerVariant.size}</div>
        <S.Details>
          <PriceString {...offerVariant.price} />
          {offerVariant.compareAtPrice && (
            <S.CompareAtPrice>
              <PriceString {...offerVariant.compareAtPrice} />
            </S.CompareAtPrice>
          )}
          <DashboardPermissionGuard permission="contributions.profit">
            <S.Separator />
            <div>
              Profit: {!isNil(cost) ? <ProfitString value={Number(profit)} /> : <>&ndash;</>}
            </div>
          </DashboardPermissionGuard>
        </S.Details>
      </S.Content>
      <S.Arrow>
        <Icon component={ArrowShortRightIcon} height={12} />
      </S.Arrow>
    </S.Container>
  )
}
